module.exports = __webpack_public_path__ + "images/category_lp/jewel/assessment_achievements/4_1c5e95c769affb70973a58a72508bd6e.jpg";